/* eslint-disable max-classes-per-file */

import { commonIcons } from '@apps-common/config/icons'
import { getControlNotificationWrapperClasses } from '@apps-common/hooks/useControlColors'
import { INotificationPayload } from '@apps-common/types/portal/push-registration'

import { PushProgramTaskStatusAction } from './unit-task'

enum PushUnitControlAction {
  arm = 'arm',
  disarm = 'disarm',
  locked = 'locked',
  unlocked = 'unlocked',
  on = 'on',
  off = 'off',
  info = 'info'
}
export class PushUnitControl {
  public static destination = 'unit-control'

  public static action = PushUnitControlAction
}

export class PushProgramTask {
  public static destination = 'program-task'

  public static action = PushProgramTaskStatusAction
}

enum PushUnitActivationAction {
  startedPowerUp = 'started-powered-up',
  started = 'started',
  success = 'success',
  failed = 'failed'
}
export class PushUnitActivation {
  public static destination = 'unit-activation'

  public static action = PushUnitActivationAction
}

const controlIconWrapper = (Icon: any, type: 'arm' | 'disarm' | 'locked' | 'unlocked' | 'on' | 'off' | 'info') => {
  return <div className={getControlNotificationWrapperClasses(type)}>{Icon}</div>
}

const iconWrapper = (Icon: any, type: 'info' | 'success' | 'warning' | 'error') => {
  switch (type) {
    case 'success':
      return <div className='bg-success text-on-success rounded-full p-[2px] border border-on-success'>{Icon}</div>

    case 'warning':
      return <div className='bg-warning text-on-warning rounded-full p-[2px] border border-on-warning'>{Icon}</div>

    case 'error':
      return <div className='bg-error text-on-error rounded-full p-[2px] border border-on-error'>{Icon}</div>

    default:
      return <div className='bg-info text-on-info rounded-full p-[2px] border border-on-info'>{Icon}</div>
  }
}

const activationIconWrapper = (Icon: any, type: 'info' | 'success' | 'warning' | 'error') => {
  switch (type) {
    case 'success':
      return (
        <div className='w-[28px] h-[28px] max-w-[28px] max-h-[28px] bg-success text-on-success rounded-full p-[3px] border border-on-success flex items-center justify-center'>
          {Icon}
        </div>
      )

    case 'warning':
      return (
        <div className='w-[28px] h-[28px] max-w-[28px] max-h-[28px] bg-warning text-on-warning rounded-full p-[3px] border border-on-warning flex items-center justify-center'>
          {Icon}
        </div>
      )

    case 'error':
      return (
        <div className='w-[28px] h-[28px] max-w-[28px] max-h-[28px] bg-error text-on-error rounded-full p-[3px] border border-on-error flex items-center justify-center'>
          {Icon}
        </div>
      )

    default:
      return (
        <div className='w-[28px] h-[28px] max-w-[28px] max-h-[28px] bg-info text-on-info rounded-full p-[3px] border border-on-info flex items-center justify-center'>
          {Icon}
        </div>
      )
  }
}

type PushIconType =
  | 'arm'
  | 'disarm'
  | 'locked'
  | 'unlocked'
  | 'on'
  | 'off'
  | 'info'
  | 'power'
  | 'activation'
  | 'fire'
  | 'medical'
  | 'panic'
  | 'restore'
  | 'schedule'
  | 'trouble'

export const buildPushNotificationIcon = (payload: INotificationPayload) => {
  const { destination, action, icon } = payload?.data || {}

  console.log('PUSH =>', payload)

  if (destination && destination === PushUnitControl.destination) {
    switch (action) {
      case PushUnitControl.action.arm:
        return controlIconWrapper(<commonIcons.armed />, 'arm')

      case PushUnitControl.action.disarm:
        return controlIconWrapper(<commonIcons.disarmed />, 'disarm')

      case PushUnitControl.action.locked:
        return controlIconWrapper(<commonIcons.armed />, 'locked')

      case PushUnitControl.action.unlocked:
        return controlIconWrapper(<commonIcons.disarmed />, 'unlocked')

      case PushUnitControl.action.on:
        return controlIconWrapper(<commonIcons.controlOn />, 'on')

      case PushUnitControl.action.off:
        return controlIconWrapper(<commonIcons.controlOff />, 'off')

      default:
        return controlIconWrapper(<commonIcons.toastInfo />, 'info')
    }
  }

  if (destination && destination === PushUnitActivation.destination) {
    switch (action) {
      case PushUnitActivation.action.startedPowerUp:
        return activationIconWrapper(<commonIcons.activateOnPowerUp />, 'info')

      case PushUnitActivation.action.started:
        return activationIconWrapper(<commonIcons.activateNow />, 'info')

      case PushUnitActivation.action.success:
        return activationIconWrapper(<commonIcons.toastSuccess className='text-[1.6rem]' />, 'success')

      case PushUnitActivation.action.failed:
        return activationIconWrapper(<commonIcons.toastWarning />, 'warning')

      default:
        return activationIconWrapper(<commonIcons.toastInfo />, 'info')
    }
  }

  if (destination && destination === PushProgramTask.destination) {
    console.log(action, destination)
    switch (action) {
      case PushProgramTask.action.pending:
        return iconWrapper(<commonIcons.toastInfo />, 'info')

      case PushProgramTask.action.processing:
        return iconWrapper(<commonIcons.toastInfo />, 'info')

      case PushProgramTask.action.awaitingRetry:
        return iconWrapper(<commonIcons.toastWarning />, 'warning')

      case PushProgramTask.action.success:
        return iconWrapper(<commonIcons.toastSuccess />, 'success')

      case PushProgramTask.action.cancelled:
        return iconWrapper(<commonIcons.toastError />, 'error')

      default:
        return iconWrapper(<commonIcons.toastInfo />, 'info')
    }
  }

  if (icon) {
    const pushIcon = icon as PushIconType

    if (pushIcon === 'arm') {
      return controlIconWrapper(<commonIcons.armed />, 'arm')
    } else if (pushIcon === 'disarm') {
      return controlIconWrapper(<commonIcons.disarmed />, 'disarm')
    } else if (pushIcon === 'locked') {
      return controlIconWrapper(<commonIcons.armed />, 'locked')
    } else if (pushIcon === 'unlocked') {
      return controlIconWrapper(<commonIcons.disarmed />, 'unlocked')
    } else if (pushIcon === 'on') {
      return controlIconWrapper(<commonIcons.controlOn />, 'on')
    } else if (pushIcon === 'off') {
      return controlIconWrapper(<commonIcons.controlOff />, 'off')
    } else if (pushIcon === 'info') {
      return iconWrapper(<commonIcons.toastInfo />, 'info')
    } else if (pushIcon === 'power') {
      return activationIconWrapper(<commonIcons.power />, 'info')
    } else if (pushIcon === 'activation') {
      return activationIconWrapper(<commonIcons.toastError />, 'error')
    } else if (pushIcon === 'fire') {
      return iconWrapper(<commonIcons.mmEventFire />, 'error')
    } else if (pushIcon === 'medical') {
      return iconWrapper(<commonIcons.mmEventMedical />, 'error')
    } else if (pushIcon === 'panic') {
      return iconWrapper(<commonIcons.mmEventMedical />, 'error')
    } else if (pushIcon === 'restore') {
      return iconWrapper(<commonIcons.checkDouble />, 'success')
    } else if (pushIcon === 'schedule') {
      return iconWrapper(<commonIcons.schedule />, 'info')
    } else if (pushIcon === 'trouble') {
      return iconWrapper(<commonIcons.mmEventTrouble />, 'warning')
    } else {
      return iconWrapper(<commonIcons.toastInfo />, 'info')
    }
  }

  return iconWrapper(<commonIcons.toastInfo />, 'info')
}
